'use strict';

require('lity/dist/lity');

require('./../sections/blog-preview/BlogPreview');

require('./../sections/featured-stats/FeaturedStats');

require('./../sections/image-text/ImageText');

require('./../sections/products-carousel/ProductsCarousel');

require('./../sections/results-carousel/ResultsCarousel');

require('./../sections/skin-concerns/SkinConcerns');

require('./../sections/quote-showcase/QuoteShowcase');

require('./../sections/about/About');

require('./../sections/contact/Contact');

require('./../sections/cart/CartDrawer');

require('./../objects/form/Form');

require('./../sections/home-hero-full/home-hero-full');